import type { ApiRota } from "pages/rota/types/ApiRota";
import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelProdutoresSimp({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<ApiRota>> {
	return newRequest({
		url: "Relatorio/ProdutoresSimp",
		type: "get",
		idpk: undefined,
		params,
	});
}
